export { default } from "./ColumnTemplatesPanel.jsx"
